import {
  addDoc,
  collection,
  doc,
  increment,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

export async function saveFacilityRating({
  shiftId,
  workerUid,
  facilityId,
  plannerUid,
  professionalism,
  communication,
  reliability,
  clinicalSkills,
  wouldRequestAgain,
}) {
  const values = [
    professionalism,
    communication,
    reliability,
    clinicalSkills,
  ].map(Number);

  const average =
    values.reduce((a, b) => a + b, 0) / values.length;

  await addDoc(collection(db, "workerRatings"), {
    shiftId,
    workerUid,
    facilityId,

    professionalism,
    communication,
    reliability,
    clinicalSkills,

    wouldRequestAgain,

    average,

    createdBy: plannerUid,
    createdAt: serverTimestamp(),
  });

  await updateDoc(doc(db, "users", workerUid), {
    facilityRatingTotal: increment(average),
    facilityRatingCount: increment(1),
    updatedAt: serverTimestamp(),
  });

  await updateDoc(doc(db, "shifts", shiftId), {
    ratingStatus: "completed",
    ratedAt: serverTimestamp(),
  });
}